import { Center, Text } from '@chakra-ui/react';

export const NotificationsRosterPage = () => {
  return (
    <Center height="100%">
      <Text color="whiteAlpha.600">Roster - Coming Soon</Text>
    </Center>
  );
};
